import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Confirm from 'common/components/Confirm/Confirm';
import { useTranslation } from 'react-i18next';

const ConfirmWrap = ({
  children, message,
}) => {
  const [modalActive, setModalActive] = useState(false);
  const { t } = useTranslation();
  const child = React.Children.only(children);
  const confirmMessage = message ?? t('common.confirmMessage');

  const handleShow = () => setModalActive(true);
  const closeModal = () => setModalActive(false);

  const handleConfirm = () => {
    if (child.props.onClick) child.props.onClick();
    setModalActive(false);
  };

  return (
    <>
      {React.cloneElement(child, { onClick: handleShow })}
      {modalActive && (<Confirm message={confirmMessage} confirmModal={handleConfirm} closeModal={closeModal} />) }
    </>
  );
};

ConfirmWrap.propTypes = {
  message: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ConfirmWrap.defaultProps = {
  message: null,
};

export default ConfirmWrap;
